<template>
  <div :class="['mic-loader', spinnerColor]">
    <div :class="['mic-loader__spinner', spinnerColor]" />
  </div>
</template>

<script>
export default {
  name: 'SpinningLoader',
  props: {
    color: {
      type: String,
      default: 'navy'
    }
  },
  computed: {
    spinnerColor () {
      return this.color === 'navy' ? 'navy' : 'white'
    }
  }
}
</script>

<style lang="scss" scoped>
.mic-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;

  &.navy {
    background-color: $spinner-bg;
  }

  &.white {
    background-color: $white;
  }

  @media (max-width: $screen-md) {
    width: 40px;
    height: 40px;
  }

  &__spinner {
    border-radius: 50%;
    width: 34px;
    height: 34px;
    animation: spin 2s linear infinite;
    background-color: $spinner-bg;

      &.navy {
        border: 3px solid rgba(255, 255, 255, 0.12);
        border-top: 3px solid white;
        background-color: $spinner-bg;
      }

      &.white {
        border: 3px solid rgba($spinner-bg, 0.12);
        border-top: 3px solid $spinner-bg;
        background-color: $white;
      }

    @media (max-width: $screen-md) {
      width: 28px;
      height: 28px;
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}
</style>
